<template>
  <dialogModel
    :title="dialogTitle"
    width="1200px"
    :visible.sync="VisibleDeRe"
    :footer="DeRe == 1"
    @handleClose="handleClose"
    @handleOk="handleUnderstand"
  >
    <div class="dialog-content">
      <div class="Content">
        <div class="section-row">
          <div class="section-col">
            <div class="title">企业信息</div>
            <div class="Content-box">
              <div class="title-p">企业名称</div>
              <div class="title-con">{{ row.orderCompanyName }}</div>
            </div>
            <div
              class="Content-box"
              v-if="
                row.orderCompanyType != null || row.customerCompanyType != null
              "
            >
              <div class="title-p">企业类型</div>
              <div class="title-con">{{ companyTypeText }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">纳税类型</div>
              <div class="title-con">
                {{
                  row.orderTaxType == 1 ? "一般纳税人" : "小规模纳税人"
                }}
              </div>
            </div>
            <div class="Content-box">
              <div class="title-p">统一社会信用代码</div>
              <div class="title-con">{{ row.orderCreditCode }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">法定代表人(负责人)</div>
              <div class="title-con">{{ row.orderLegalPerson }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">联系电话</div>
              <div class="title-con">{{ row.orderCompanyPhone }}</div>
            </div>
          </div>

          <div class="section-col">
            <div class="title">服务信息</div>
            <div class="Content-box">
              <div class="title-p">服务类型</div>
              <div class="title-con">{{ row.operationTypeName }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">服务类别</div>
              <div class="title-con">{{ row.iprTypeName }}</div>
            </div>
            <div class="Content-box" v-if="row.iprType == 0">
              <div class="title-p">商标类型</div>
              <div class="title-con">
                {{ row.itemType == 0 ? "名称" : "图标" }}
              </div>
            </div>
            <div class="Content-box" v-if="row.iprType == 0">
              <div class="title-p">商标信息</div>
              <div class="title-con" v-if="row.itemType == 0">
                {{ row.itemContent }}
              </div>
              <div class="img-box" v-else>
                <img :src="row.itemContent" alt="" />
              </div>
            </div>
            <div class="Content-box" v-if="row.iprType == 1">
              <div class="title-p">著作权名称</div>
              <div class="title-con">{{ row.itemContent }}</div>
            </div>
            <div class="Content-box" v-if="row.iprType == 2">
              <div class="title-p">专利名称</div>
              <div class="title-con">{{ row.itemContent }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">经营范围</div>
              <div class="title-con">{{ row.businessScope }}</div>
            </div>
          </div>
        </div>

        <div class="section-bottom">
          <div class="title">订单信息</div>
          <div class="info-grid">
            <div class="Content-box">
              <div class="title-p">服务金额</div>
              <div class="title-con">{{ row.amount }}元</div>
            </div>
            <div class="Content-box">
              <div class="title-p">订单时间</div>
              <div class="title-con">{{ row.orderTime || "--" }}</div>
            </div>
          </div>
          <div class="Content-box full-row">
            <div class="title-p">备注</div>
            <div class="title-con">{{ row.remark || "--" }}</div>
          </div>
        </div>

        <div
          class="section-bottom refund-block"
          v-if="DeRe == 1 || DeRe == 2"
        >
          <div class="title">退款信息</div>
          <div class="info-grid">
            <div class="Content-box" v-if="DeRe == 1">
              <div class="title-p">退款金额</div>
              <div class="title-con">{{ row.amount }}元</div>
            </div>
            <div class="Content-box" v-if="DeRe == 2">
              <div class="title-p">退款原因</div>
              <div class="title-con">{{ dataObj.refundReason || "--" }}</div>
            </div>
            <div class="Content-box" v-if="DeRe == 2">
              <div class="title-p">实际退款金额</div>
              <div class="title-con">
                {{
                  dataObj.refundAmount != null ? dataObj.refundAmount : "--"
                }}元
              </div>
            </div>
          </div>
          <div class="Instruction">(实际退款金额需后台审核)</div>
          <div class="Content-box full-row refund-reason" v-if="DeRe == 1">
            <div class="title-p">退款原因</div>
            <div class="title-con refund-input">
              <el-input
                type="textarea"
                class="textarea-lg"
                placeholder="请输入退款原因"
                v-model="textarea"
                :rows="5"
                maxlength="1500"
                show-word-limit
                resize="none"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </dialogModel>
</template>

<script>
export default {
  props: {
    VisibleDeRe: {},
    DeRe: {}, ///0详情1申请代开发票退款 2退款详情
    row: {}, //数据
    seller: {}, //销售方信息

    dataObj: {}, //申请退款中需要展示的数据
    businessInfo: {}, //字符串转json的数据
  },
  components: {},
  data() {
    return {
      textarea: "",
    };
  },
  computed: {
    dialogTitle() {
      return this.DeRe == 0 ? "详情" : "申请退款";
    },
    companyTypeText() {
      const map = ["有限公司", "个体户", "子公司", "分公司", "其他"];
      const t =
        this.row &&
        (this.row.orderCompanyType != null
          ? this.row.orderCompanyType
          : this.row.customerCompanyType);
      return map[t] != null ? map[t] : "--";
    },
  },
  created() {},
  methods: {
    // 取消
    handleClose() {
      this.$emit("handleCloseDeRe");
      this.textarea = "";
    },
    // 确认
    handleUnderstand() {
      this.$emit("handleConfirmDeRe", this.textarea);
      this.textarea = "";
    },
  },
};
</script>

<style scoped lang="less">
@import "../../../Bookkeeping/components/bookkeeping-detail-dialog.less";

.Content .Content-box {
  img {
    width: 100px;
    height: 100px;
  }
  .img-box {
    flex: 1;
    display: flex;
    justify-content: flex-start;
  }
}
</style>
